export type ScoringValues = {
  rankingType: number | string;
  participation: number | string;
  matchWinWB: number | string;
  matchWinLB: number | string;
  matchWinGroup: number | string;
  matchLoseWB: number | string;
  matchLoseLB: number | string;
  matchLoseGroup: number | string;
  singleElimPlacement: (number | string)[];
  doubleElimPlacement: (number | string)[];
};

export type ScoringPreset = {
  id: string;
  name: string;
  values: ScoringValues[];
  leaderboardWindowWeeks: number | null;
  leaderboardMaxTournaments: number | null;
  rankGroupPlacement: boolean;
};

export const defaultScoringValues: ScoringValues = {
  rankingType: 100,
  participation: 5,
  matchWinWB: 10,
  matchWinLB: 8,
  matchWinGroup: 6,
  matchLoseWB: 2,
  matchLoseLB: 1,
  matchLoseGroup: 1,
  singleElimPlacement: [100, 50, 30, 20, 7, 7, 7, 7, 0],
  doubleElimPlacement: [100, 50, 30, 20, 10, 10, 5, 5, 0],
};

export const scoringPresets: ScoringPreset[] = [
  {
    id: 'RAQT',
    name: 'RAQT Default',
    values: [{ ...defaultScoringValues }],
    leaderboardWindowWeeks: null,
    leaderboardMaxTournaments: null,
    rankGroupPlacement: false,
  },
  {
    id: 'SPT',
    name: 'Swedish Pickleball Tour',
    values: [
      {
        rankingType: 100,
        participation: 2,
        matchWinWB: 2,
        matchWinLB: 1,
        matchWinGroup: 2,
        matchLoseWB: 0,
        matchLoseLB: 0,
        matchLoseGroup: 0,
        singleElimPlacement: [100, 50, 30, 20, 7, 7, 7, 7, 0],
        doubleElimPlacement: [100, 50, 30, 20, 10, 10, 5, 5, 0],
      },
      {
        rankingType: 400,
        participation: 2,
        matchWinWB: 8,
        matchWinLB: 4,
        matchWinGroup: 8,
        matchLoseWB: 0,
        matchLoseLB: 0,
        matchLoseGroup: 0,
        singleElimPlacement: [400, 200, 120, 80, 20, 20, 20, 20, 0],
        doubleElimPlacement: [400, 200, 120, 80, 40, 40, 20, 20, 0],
      },
      {
        rankingType: 800,
        participation: 2,
        matchWinWB: 16,
        matchWinLB: 8,
        matchWinGroup: 16,
        matchLoseWB: 0,
        matchLoseLB: 0,
        matchLoseGroup: 0,
        singleElimPlacement: [800, 400, 240, 160, 40, 40, 40, 40, 0],
        doubleElimPlacement: [800, 400, 240, 160, 80, 80, 40, 40, 0],
      },
    ],
    leaderboardWindowWeeks: 52,
    leaderboardMaxTournaments: null,
    rankGroupPlacement: true,
  },
  {
    id: 'PI',
    name: 'Pickleball Ireland Tour',
    rankGroupPlacement: false,
    values: [
      {
        rankingType: 2000,
        participation: 0,
        matchWinWB: 0,
        matchWinLB: 0,
        matchWinGroup: 0,
        matchLoseWB: 0,
        matchLoseLB: 0,
        matchLoseGroup: 0,
        singleElimPlacement: [
          2000, 1600, 1200, 800, 400, 400, 400, 400, 200, 200, 200, 200, 200, 200, 200, 200, 50,
        ],
        doubleElimPlacement: [
          2000, 1600, 1200, 800, 400, 400, 400, 400, 200, 200, 200, 200, 200, 200, 200, 200, 50,
        ],
      },
    ],
    leaderboardWindowWeeks: null,
    leaderboardMaxTournaments: null,
  },
  {
    id: 'SAP',
    name: 'South Africa Pickleball',
    rankGroupPlacement: false,
    values: [
      {
        rankingType: 30,
        participation: 0,
        matchWinWB: 0,
        matchWinLB: 0,
        matchWinGroup: 0,
        matchLoseWB: 0,
        matchLoseLB: 0,
        matchLoseGroup: 0,
        singleElimPlacement: [30, 18, 9, 9, 5, 5, 5, 5, 0],
        doubleElimPlacement: [30, 18, 9, 9, 5, 5, 5, 5, 0],
      },
      {
        rankingType: 60,
        participation: 0,
        matchWinWB: 0,
        matchWinLB: 0,
        matchWinGroup: 0,
        matchLoseWB: 0,
        matchLoseLB: 0,
        matchLoseGroup: 0,
        singleElimPlacement: [60, 36, 18, 18, 10, 10, 10, 10, 5, 5, 5, 5, 5, 5, 5, 5, 0],
        doubleElimPlacement: [60, 36, 18, 18, 10, 10, 10, 10, 5, 5, 5, 5, 5, 5, 5, 5, 0],
      },
      {
        rankingType: 100,
        participation: 0,
        matchWinWB: 0,
        matchWinLB: 0,
        matchWinGroup: 0,
        matchLoseWB: 0,
        matchLoseLB: 0,
        matchLoseGroup: 0,
        singleElimPlacement: [
          100, 60, 36, 36, 20, 20, 20, 20, 10, 10, 10, 10, 10, 10, 10, 10,
          5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 0,
        ],
        doubleElimPlacement: [
          100, 60, 36, 36, 20, 20, 20, 20, 10, 10, 10, 10, 10, 10, 10, 10,
          5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 0,
        ],
      },
      {
        rankingType: 200,
        participation: 0,
        matchWinWB: 0,
        matchWinLB: 0,
        matchWinGroup: 0,
        matchLoseWB: 0,
        matchLoseLB: 0,
        matchLoseGroup: 0,
        singleElimPlacement: [
          200, 140, 100, 100, 60, 60, 60, 60, 36, 36, 36, 36, 36, 36, 36, 36,
          18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 0,
        ],
        doubleElimPlacement: [
          200, 140, 100, 100, 60, 60, 60, 60, 36, 36, 36, 36, 36, 36, 36, 36,
          18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 18, 0,
        ],
      },
      {
        rankingType: 300,
        participation: 0,
        matchWinWB: 0,
        matchWinLB: 0,
        matchWinGroup: 0,
        matchLoseWB: 0,
        matchLoseLB: 0,
        matchLoseGroup: 0,
        singleElimPlacement: [
          300, 210, 140, 140, 100, 100, 100, 100, 60, 60, 60, 60, 60, 60, 60, 60,
          30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 0,
        ],
        doubleElimPlacement: [
          300, 210, 140, 140, 100, 100, 100, 100, 60, 60, 60, 60, 60, 60, 60, 60,
          30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 0,
        ],
      },
      {
        rankingType: 500,
        participation: 0,
        matchWinWB: 0,
        matchWinLB: 0,
        matchWinGroup: 0,
        matchLoseWB: 0,
        matchLoseLB: 0,
        matchLoseGroup: 0,
        singleElimPlacement: [
          500, 350, 250, 250, 150, 150, 150, 150, 90, 90, 90, 90, 90, 90, 90, 90,
          45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 0,
        ],
        doubleElimPlacement: [
          500, 350, 250, 250, 150, 150, 150, 150, 90, 90, 90, 90, 90, 90, 90, 90,
          45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 0,
        ],
      },
    ],
    leaderboardWindowWeeks: 52,
    leaderboardMaxTournaments: 6,
  },
];
